import { type TFunction } from "i18next";
import countryConfig from "$/open_dict/country.json";
import { I18nNamespace } from "@/const/i18nNamespace";
import { type AddressInfo } from "@/modal/openAddressModal";
import { type GuestInfo } from "@/store/useRegistrationData";
import { getDefaultLang, LanguageKind } from "@/comps/ChooseLanguage";
import { addressMapToList } from "./address";
import { type CountryCodeValue } from "@/main";

export const renderNameString = (
  familyName: string,
  givenName: string,
  t: TFunction<"translation", undefined>,
) => {
  const reverse = getDefaultLang() === LanguageKind.EN;
  if (!familyName && !givenName) {
    return t("common:unknown");
  }
  const nameArray = reverse ? [givenName, familyName] : [familyName, givenName];
  return nameArray.filter(Boolean).join(" ");
};

export const renderPhoneString = ({ number, kind }: GuestInfo["tel"]) => {
  if (!number || !kind) {
    return "";
  }
  const phoneCode = countryConfig[kind].extra.tel;
  return phoneCode ? `${phoneCode} ${number}` : number;
};

export const renderResidenceCountryString = (
  residenceCountry: CountryCodeValue | "",
  t: TFunction<"translation", undefined>,
) => {
  return residenceCountry
    ? t(`${I18nNamespace.COUNTRY}:${residenceCountry}`)
    : "";
};

export const renderAddressString = (
  address: AddressInfo,
  t: TFunction<"translation", undefined>,
) => {
  const parts: string[] = [];
  const { residenceCountry, geoInfos, postcode, ...restAddresses } = address;
  parts.push(geoInfos.map((item) => item.name).join(""));
  parts.push(addressMapToList(restAddresses).filter(Boolean).join(""));
  const postalCodeStr =
    residenceCountry === "jpn" && postcode ? `〒${postcode}` : postcode;
  parts.push(postalCodeStr);
  return [
    renderResidenceCountryString(residenceCountry, t),
    parts.filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(" · ");
};
